// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-container[data-v-20af9744] {\n  display: flex;\n  min-height: calc(100vh - 320px);\n  flex-direction: column;\n  justify-content: center;\n  text-align: center;\n  font-size: 24px;\n}\n@media (max-width: 768px) {\n.error-container[data-v-20af9744] {\n    height: calc(100vh - 525px);\n}\n}\nh2[data-v-20af9744] {\n  line-height: 1em;\n}\nh2 a[data-v-20af9744] {\n  color: #9f26b599;\n}\nh2 a[data-v-20af9744]:hover {\n  color: #9f26b5ff;\n}", ""]);
// Exports
module.exports = exports;
